"use client";
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import HeaderInner from "../../utility/HeaderInner";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const CeoDesk = () => {
  return (
    <div className="mt-5" style={{backgroundColor:"#fff"}} >
      {/* Banner Section */}
      <HeaderInner
        title={"Chief Executive Officer"}
        shortDescription={"Message from the CEO"}
      />

      {/* CEO Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row g-5 align-items-start">
            {/* CEO img + Social */}
            <div className="col-lg-4 osition-relative">
              <img
                src="img12.jpg"
                alt="V S N Raju"
                className="img-fluid rounded"
              />
              {/* <div className="position-absolute bottom-0 start-0 mb-3 ms-3 d-flex gap-3 bg-white bg-opacity-75 p-2 rounded">
                <Link to="#" className="text-primary hover-opacity">
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link to="#" className="text-danger hover-opacity">
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link to="#" className="text-info hover-opacity">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
                <Link to="#" className="text-danger hover-opacity">
                  <i className="fab fa-pinterest-p"></i>
                </Link>
              </div> */}
            </div>

            {/* CEO Content */}
            <div className="col-lg-8">
              {/* Heading */}
              <motion.div
                className="border-bottom pb-3 mb-4"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <h3 className="fw-bold h3">V S N Raju</h3>
                <span className="text-primary d-block mt-1 fs-5">
                  Managing Director & CEO
                </span>
              </motion.div>

              {/* Bio */}
              <motion.div
                className="text-secondary lh-lg"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <p>
                  V S N Raju is an electronics and communication engineer from the
                  University of Madras and holds an extensive experience of
                  about two decades in sales, marketing and operations. Today he
                  is the Director & Chief Executive Officer of{" "}
                  <span className="fw-semibold">
                    COEMPT EDUTECK PRIVATE LIMITED
                  </span>
                  , one of India’s leading teaching, learning and examination
                  solution providers.
                </p>

                <p>
                  Before joining COEMPT EDUTECK, he was a successful business
                  partner of{" "}
                  <span className="fw-semibold">
                    National Institute of Sales (NIS)
                  </span>
                  , a division of NIIT. During this tenure, he was associated
                  with many promising initiatives involving both students and
                  corporate enterprises. He also worked with{" "}
                  <span className="fw-semibold">
                    Andhra Electronics Limited
                  </span>
                  , spearheading key marketing initiatives in the government and
                  export sectors.
                </p>

                <p>
                  Beyond his corporate role, Raju actively contributes as a
                  member of several panels and boards of educational
                  institutions and developmental forums. He is also a{" "}
                  <span className="fw-semibold">
                    trustee of the Centre for Entrepreneurship Development,
                    Tamil Nadu (CED-TN)
                  </span>
                  , recognized by the Ministry of Small Scale Industry,
                  Government of India, and the Industries Department, Government
                  of Tamil Nadu.
                </p>

                <p>
                  Raju firmly believes in{" "}
                  <span className="fw-semibold text-primary">
                    technology as a catalyst
                  </span>{" "}
                  to empower teachers and students in their teaching-learning
                  endeavors. Under his leadership, COEMPT EDUTECK has partnered
                  with universities, educational institutions, and government
                  departments to deliver turnkey ICT solutions. The company has
                  also collaborated with{" "}
                  <span className="fw-semibold">NASSCOM</span> to assess entry
                  level talent for IT-BPM companies.
                </p>

                <p>
                  In recognition of his progressive initiatives in education
                  enablement, Raju was honored with the title of{" "}
                  <span className="fw-semibold text-success">
                    “Emerging Leader”
                  </span>{" "}
                  at{" "}
                  <span className="fw-semibold">
                    The World's Greatest Brands & Leaders Asia & GCC Summit
                  </span>
                  .
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CeoDesk;
